/**
 * ⚠️ 재수출이다. 본체는 `src/components/platform-icon` 이다 — 두 화면 이상이 쓰는 부품이라
 * 공용 자리로 올렸다. 기존 import 경로를 바꾸지 않으려고 여기서 다시 내보낸다.
 */
export { PlatformIcon } from 'src/components/platform-icon';
